import PlatformFunctionBase from "@/commons/PlatformFunctionBase";
class PlatformFunction extends PlatformFunctionBase {
  constructor() {
    super();
    this.store = store;
    this.router = router;
  }
  /**
   * Hàm đăng xuất
   * created by pdthien 27.01.2021
   */
  logout() {
    // this.APUIFunction.logoutAMIS();
  }
  /**
   * Khởi tạo APUI
   * @param {*} userData
   * @param {*} isAdmin
   * @param {*} appVersion
   * @param {*} isNoLicense
   * created by pdthien 27.01.2021
   */
  init(userData, isAdmin, appVersion, isNoLicense) {
    // this.APUIFunction.init(userData, isAdmin, appVersion, isNoLicense);
  }
  /**
   *
   */
  notificationBox(userData) {
    let self = this,
      targetID = null,
      templates = [];
    var notificationBox = new this.APUI.NotificationBox({
      appCode: __appInfo.ApplicationCode,
      trigger: targetID, //selector của trigger
      limit: 30, //số thông báo 1 lần load
      theme: "dark", //màu quả chuông sáng hoặc “dark” tối
      //templates cho câu thông báo. Xem ví dụ bên dưới
      templates: templates,
      //bộ icon cho thông báo, key là action name, value là tên class của icon
      icons: {},
      //gọi khi click vào thông báo, truyền item và data ra
      onItemClick: function (item, data) {

      },
      socketConfig: {
        ApplicationCode: __appInfo.ApplicationCode,
        UserID: userData.UserID,
        TenantID: userData.TenantID,
        //gọi ra khi có thông báo
        OnDataChanged: function (data) {
          console.log(data);
        }
      },

    });

    //gọi load luôn để ra số bản ghi chưa đoc ở quả chuông
    notificationBox.load();
  }
  createdMenuAccount() {
    new this.APUI.AccountMenu({
      trigger: "#AMIS_Account",
      width: "300px",
      extendItems: []
    });
  }
}
import store from "@/stores/store";
import router from "@/router";
//import AvatarService from "@/api/base/employee/AvatarService.js";
export default {
  install(Vue) {
    const platformFunction = new PlatformFunction();
    Vue.prototype.$PlatformFunction = platformFunction;
  }
};
